export const HOME_SPOTLIGHT_DEVICE_FIELDS: readonly string[] = [
  'id',
  'deviceId',
  'azureADDeviceId',
  'deviceName',
  'managedDeviceName',
  'userDisplayName',
  'userPrincipalName',
];

export const HOME_SPOTLIGHT_USER_FIELDS: readonly string[] = [
  'id',
  'displayName',
  'userPrincipalName',
  'jobTitle',
  'department',
];
